import { composeClassNames } from "@faedev/editor-utils";
import { useState } from "react";
import { Button } from "react-bootstrap";
import Content from "src/components/Content";
import Heading from "src/components/Heading";
import Translate from "src/components/Translate";
import WhyToUseCompanies from "src/components/WhyToUseCompanies";
import WhyToUseInstructors from "src/components/WhyToUseInstructors";
import WhyToUseYogis from "src/components/WhyToUseYogis";
import constants from "src/constants";
import { sButton } from "src/styles/sButton.module.scss";
import { sGroupTitle } from "src/styles/sGroupTitle.module.scss";
import { sWhyToUse } from "src/styles/sWhyToUse.module.scss";

type Props = {
  backgroundColor?: string;
  className?: (string | string) | null | undefined;
};

function WhyToUse({ backgroundColor, className }: Props) {
  const [activeContent, setActiveContent] = useState<
    "yogis" | "instructors" | "companies"
  >("yogis");

  return (
    <Content
      style={{ background: backgroundColor || constants.Theme.white }}
      className={composeClassNames([sWhyToUse, className, "whyToUse"])}
      fluid={`full`}
      verticalSpace={`lg`}
    >
      <div className="whyToUse-wrapper">
        <Heading
          type={`h2`}
          title={<Translate tKey={`Why use Anandita?`} />}
          className={composeClassNames([sGroupTitle, "whyToUse-title"])}
        />
        <p className={"whyToUse-subtitle"}>
          <Translate
            tKey={`We ask the community for its needs and listen to what it says.`}
          />
        </p>
        <div className="whyToUse-switch-wrapper">
          <div className="whyToUse-switch">
            <Button
              variant={`outline-primary`}
              size={`sm`}
              className={composeClassNames([
                sButton,
                `switch-button`,
                activeContent === "yogis" ? "active" : null,
              ])}
              onClick={() => setActiveContent("yogis")}
            >
              <Translate tKey={`Yogis`} />
            </Button>
            <Button
              variant={`outline-primary`}
              size={`sm`}
              className={composeClassNames([
                sButton,
                `switch-button`,
                activeContent === "instructors" ? "active" : null,
              ])}
              onClick={() => setActiveContent("instructors")}
            >
              <Translate tKey={`Instructors`} />
            </Button>
            {constants.Show.homepageWhyToUseCompanies && (
              <Button
                variant={`outline-primary`}
                size={`sm`}
                className={composeClassNames([
                  sButton,
                  `switch-button`,
                  activeContent === "companies" ? "active" : null,
                ])}
                onClick={() => setActiveContent("companies")}
              >
                <Translate tKey={`Companies`} />
              </Button>
            )}
          </div>
        </div>
        {activeContent === "yogis" && <WhyToUseYogis />}
        {activeContent === "instructors" && <WhyToUseInstructors />}
        {activeContent === "companies" && <WhyToUseCompanies />}
      </div>
    </Content>
  );
}

export default WhyToUse;
